/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dnd/~/lodash/_freeGlobal.js
 ** module id = 968
 ** module chunks = 0
 **/